import { useLocation } from 'react-router-dom'

import { ApolloError, WatchQueryFetchPolicy } from 'apollo-client'

import {
  ProductKey,
  TierKey,
  useBenefitsHubUserTierQuery,
} from 'generated/types'

import { BENEFIT_PRODUCT_NAME } from '../utils/constants'

const CURRENT_BENEFITS_PRODUCT = [
  ProductKey.BenefitsWillStandard,
  ProductKey.StandardBenefitsInsurance,
  ProductKey.BenefitsGohenryStandard,
  ProductKey.BenefitsTaxfilingStandard,
]

type AvailableBenefitsType = {
  [ProductKey.BenefitsWillStandard]: boolean
  [ProductKey.StandardBenefitsInsurance]: boolean
  [ProductKey.BenefitsGohenryStandard]: boolean
  [ProductKey.BenefitsTaxfilingStandard]: boolean
}

type Result = {
  availableBenefits: AvailableBenefitsType
  error: ApolloError | undefined
  hasBenefitsHub: boolean
  loading: boolean
  tierName: string
  tierKey: TierKey | undefined
  tierPrice: number | undefined
}

export const useUserHasBenefitsHub = (
  fetchPolicy?: WatchQueryFetchPolicy,
): Result => {
  const { state } = useLocation()

  const policy = fetchPolicy || state?.fetchPolicy

  const { data, loading, error } = useBenefitsHubUserTierQuery(
    policy
      ? {
          fetchPolicy: policy,
        }
      : {},
  )

  const userTier = data?.tierSubscriptionByUserId?.tier

  const hasBenefitsHub = userTier?.products?.some((product) => {
    return product.name === BENEFIT_PRODUCT_NAME && product.active
  })

  const availableBenefits = CURRENT_BENEFITS_PRODUCT?.reduce((acc, key) => {
    const hasProduct = userTier?.products?.some((product) => {
      return product.key === key && product.active && !error && !loading
    })

    return { ...acc, [key]: hasProduct }
  }, {}) as AvailableBenefitsType

  return {
    availableBenefits,
    error,
    hasBenefitsHub: Boolean(hasBenefitsHub && !error && !loading),
    loading,
    tierName: userTier?.name ?? 'Gold',
    tierKey: userTier?.key,
    tierPrice: data?.tierSubscriptionByUserId?.tierPrice?.amount?.value,
  }
}
